module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Agreement: ",
      "title": _vm.form.name,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onAdd
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "agreementDetailsForm",
    attrs: {
      "model": _vm.form,
      "label-position": "top"
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Name",
      "prop": "name",
      "disabled": _vm.disabled,
      "placeholder": "Name of agreement (must be unique)"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Structure Details")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "justify": "left",
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-input', {
    attrs: {
      "label": "Status",
      "prop": "status",
      "list": [{
        label: 'Active',
        value: 'Active'
      }, {
        label: 'Inactive',
        value: 'Inactive'
      }],
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Category",
      "prop": "category",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.category),
      callback: function($$v) {
        _vm.$set(_vm.form, "category", $$v)
      },
      expression: "form.category"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Allowed Heights",
      "prop": "heights",
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.heights),
      callback: function($$v) {
        _vm.$set(_vm.form, "heights", $$v)
      },
      expression: "form.heights"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Min. Height",
      "prop": "minHeight",
      "decimals": 0,
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.minHeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "minHeight", $$v)
      },
      expression: "form.minHeight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Max. Height",
      "prop": "maxHeight",
      "decimals": 0,
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.maxHeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "maxHeight", $$v)
      },
      expression: "form.maxHeight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Structure Types",
      "prop": "structures",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.structures),
      callback: function($$v) {
        _vm.$set(_vm.form, "structures", $$v)
      },
      expression: "form.structures"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("Sharer Details")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "justify": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('number-input', {
    attrs: {
      "label": "From Sharers",
      "prop": "fromSharers",
      "decimals": 0,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.fromSharers),
      callback: function($$v) {
        _vm.$set(_vm.form, "fromSharers", $$v)
      },
      expression: "form.fromSharers"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('number-input', {
    attrs: {
      "label": "To Sharers",
      "prop": "toSharers",
      "decimals": 0,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.toSharers),
      callback: function($$v) {
        _vm.$set(_vm.form, "toSharers", $$v)
      },
      expression: "form.toSharers"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Only First Sharer",
      "prop": "firstSharerOnly",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.firstSharerOnly),
      callback: function($$v) {
        _vm.$set(_vm.form, "firstSharerOnly", $$v)
      },
      expression: "form.firstSharerOnly"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Rates Sharer No.",
      "prop": "ratesBySharerNo",
      "disabled": _vm.disabled || _vm.form.ratesBySharerQty
    },
    model: {
      value: (_vm.form.ratesBySharerNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "ratesBySharerNo", $$v)
      },
      expression: "form.ratesBySharerNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Rates Sharer Qty",
      "prop": "ratesBySharerQty",
      "disabled": _vm.disabled || _vm.form.ratesBySharerNo
    },
    model: {
      value: (_vm.form.ratesBySharerQty),
      callback: function($$v) {
        _vm.$set(_vm.form, "ratesBySharerQty", $$v)
      },
      expression: "form.ratesBySharerQty"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("Rates")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "inherit",
      "max-width": "1235px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.rates,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "seqNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Months"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fromMonth",
      "label": "From",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "toMonth",
      "label": "To",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Sharers"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "telco1",
      "label": "1",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telco2",
      "label": "2",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telco3",
      "label": "3",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telco4",
      "label": "4",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telco5",
      "label": "5",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telco6",
      "label": "6",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telco7",
      "label": "7",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06fa22de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/rates/AgreementDetails.vue
// module id = 1308
// module chunks = 0